import { createContext, useContext, type ReactNode } from "react"

/**
 * The results table's CSV export, published to the run-level actions the table
 * renders in its controls row, so the run's overflow menu can host it instead
 * of a second download control sitting beside that menu.
 */
interface RunResultsCsvExport {
  disabled: boolean
  onExportCsv: () => void
}

const RunResultsCsvExportContext = createContext<RunResultsCsvExport | null>(
  null,
)

export const RunResultsCsvExportProvider = ({
  children,
  value,
}: {
  children: ReactNode
  value: RunResultsCsvExport
}) => (
  <RunResultsCsvExportContext.Provider value={value}>
    {children}
  </RunResultsCsvExportContext.Provider>
)

/**
 * Null when the actions render outside a results table, which is what tells a
 * caller to leave the CSV row out of its menu entirely.
 */
export const useRunResultsCsvExport = () =>
  useContext(RunResultsCsvExportContext)
